<template>
	<div v-if="featuresLoaded && groupFeatures.length>0" class="pt-3">
		<div class="table-responsive">
			<table class="table">
				<thead>
					<tr>
						<th>Team Name</th>
						<th
							v-for="(featureName, featureKey) in features"
							:key="featureKey"
							class="text-center"
						>
							{{ featureName }}
						</th>
						<th class="text-center">Competitors</th>
						<th class="text-center">Property Type</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="team in groupFeatures" :key="team.team_id">
						<td style="width: 30%">{{ team.team_name }}</td>
						<td
							v-for="(featureName, featureKey) in features"
							:key="`${team.team_id}-${featureKey}`"
							class="text-center"
						>
							<div class="custom-control custom-switch">
								<input
									type="checkbox"
									class="custom-control-input"
									:id="`feature-${featureKey}-${team.team_id}`"
									:checked="teamHasFeature(team.team_id, featureKey)"
									@change="
										toggleFeature(
											team.team_id,
											featureKey,
											$event.target.checked,
										)
									"
								/>
								<label
									class="custom-control-label"
									:for="`feature-${featureKey}-${team.team_id}`"
								></label>
							</div>
						</td>
						<td class="text-center" style="width: 100px">
							<input
								type="number"
								class="form-control"
								min="0"
								:value="findMaxCompetitors(team.team_id)"
								@change="updateMaxCompetitors(team.team_id, $event.target.value)"
							/>
						</td>
						<td>
							<select
								:value="findPropertyType(team.team_id)"
								@change="updatePropertyType(team.team_id, $event.target.value)"
								class="form-select form-control"
							>
								<option value="hotel">Hotel</option>
								<option value="restaurant">Restaurant</option>
								<option value="cruiseline">Cruiseline</option>
								<option value="bank">Bank</option>
							</select>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<button class="btn btn-primary ml-2" @click="saveGroupFeatures">Save Changes</button>
	</div>
	<div v-else-if="featuresLoaded && groupFeatures.length===0">
		<h6 class="header-case card-header pl-4" style="font-size: 16px">No Teams Added Yet</h6>
	</div>
	<div v-else>
		<div class="loader d-block text-center">
			<p><i class="fas fa-circle-notch fa-spin"></i></p>
			<p>Loading..</p>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		groupData: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			features: {
				surveys: 'Surveys',
				// publish_reviews: 'Publish Reviews',
				// social_feed: 'Social Feed',
				auto_translate: 'Auto Translate',
				response_approval: 'Response Approval',
			},
			groupFeatures: null,
			groupFeaturesLoading: false,
			groupFeaturesSaving: false,
			groupFeaturesSaved: false,
			featuresLoaded: false,
		};
	},
	mounted() {
		this.fetchGroupTeamsMetrics();
	},
	methods: {
		findMaxCompetitors(teamId) {
			const teamFeature = this.groupFeatures.find((f) => f.team_id === teamId);
			return teamFeature ? teamFeature.max_competitors : 0;
		},
		updateMaxCompetitors(teamId, newValue) {
			const teamIndex = this.groupFeatures.findIndex((team) => team.team_id === teamId);
			if (teamIndex !== -1) {
				this.$set(this.groupFeatures[teamIndex], 'max_competitors', parseInt(newValue, 10));
			}
		},
		findPropertyType(teamId) {
			const teamFeature = this.groupFeatures.find((f) => f.team_id === teamId);
			return teamFeature ? teamFeature.property_type : null;
		},
		updatePropertyType(teamId, newType) {
			const teamFeature = this.groupFeatures.find((f) => f.team_id === teamId);
			if (teamFeature) {
				teamFeature.property_type = newType;
			}
		},
		toggleFeature(teamId, feature, isChecked) {
			const teamIndex = this.groupFeatures.findIndex((team) => team.team_id === teamId);
			if (teamIndex === -1) return;
			const featureIndex = this.groupFeatures[teamIndex].beta_features.indexOf(feature);
			if (isChecked && featureIndex === -1) {
				this.groupFeatures[teamIndex].beta_features.push(feature);
			} else if (!isChecked && featureIndex !== -1) {
				this.groupFeatures[teamIndex].beta_features.splice(featureIndex, 1);
			}
		},
		teamHasFeature(teamId, feature) {
			const team = this.groupFeatures.find((t) => t.team_id === teamId);
			return team && team.beta_features.includes(feature);
		},
		fetchGroupTeamsMetrics() {
			this.groupFeaturesLoading = true;
			const groupId = this.groupData.groupInfo.id;
			axios
				.get(`/api/groups/${groupId}/teams-metrics`)
				.then((response) => {
					this.groupFeatures = response.data.group_teams_metrics;
					this.groupFeaturesLoading = false;
					this.featuresLoaded = true;
				})
				.catch((error) => {
					console.error('Error fetching group teams metrics:', error);
					this.groupFeaturesLoading = false;
				});
		},
		saveGroupFeatures() {
			const groupId = this.groupData.groupInfo.id;
			this.groupFeaturesSaving = true;

			axios
				.post(`/api/groups/${groupId}/update-teams-metrics`, {
					group_teams_metrics: this.groupFeatures,
				})
				.then((response) => {
					this.groupFeaturesSaving = false;
					this.groupFeaturesSaved = true;
					swal('Success!', 'Group features updated successfully.', 'success');
				})
				.catch((error) => {
					this.groupFeaturesSaving = false;
					console.error('Error saving group teams metrics:', error);
					swal('Failed!', 'Failed to update group features.', 'error');
				});
		},
	},
};
</script>

<style>
.col-1 {
	flex: 0 0 13%;
	max-width: 13%;
}
</style>
